// angular
import { Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
// interfaces & env
import { IPortfolioMember } from '@app/shared/interfaces/member.interface';
import { environment } from '@environments/environment';
// pipe & constants
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
import { socialMediaConstant } from '@app/shared/constants/social-media-data.const';

@Component({
  selector: 'pwj-team-member-card',
  standalone: true,
  imports: [NgOptimizedImage, TranslateDataPipe, ImageSourcePipe],
  templateUrl: './team-member-card.component.html',
  styleUrl: './team-member-card.component.scss',
})
export class TeamMemberCardComponent {
  public baseUrl: string = environment.baseUrl.base;
  public socialMediaConstant = socialMediaConstant;

  // inputs
  cardData = input.required<IPortfolioMember>();
}
